import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { Subdomain } from 'signup-ui-lego-core/constants/Subdomain';
export const SubdomainLocale = new Map([[Subdomain.Br, Locale.ptBr]]);
export const getSubdomainLocale = subdomain => {
  return SubdomainLocale.get(subdomain);
};